import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArFulfillmentEventsAddedReviewNotifyFollowersProps extends BaseTemplateProps {
  request: {
    name: string
  }
}

export const ArFulfillmentEventsAddedReviewNotifyFollowers: TemplateDefinition<ArFulfillmentEventsAddedReviewNotifyFollowersProps> =
  {
    renderParams: (props: ArFulfillmentEventsAddedReviewNotifyFollowersProps) => ({
      messageKey: 'notificationsDomain.templates.arFulfillmentEventsAddedReviewNotifyFollowers',
      values: {
        eventName: props?.request?.name,
      },
    }),
    getLink: (props: ArFulfillmentEventsAddedReviewNotifyFollowersProps): string => {
      if (!props) return ''
      return '/app/admin/approvals-management/approval-requests-search?tool=fulfillment_events'
    },
  }
